module.exports = __webpack_public_path__ + "ppt.png?d24652ba9d994f7fadf930ee8449a043";


//////////////////
// WEBPACK FOOTER
// ./src/assets/iconImg/ppt.png
// module id = 128
// module chunks = 0